<template>
    <div class="action-table-web" v-if="$detect == 'web'">
        <div class="row">
            <div class="col-2">
                <ldc-dropdown
                    trigger="click"
                    :action-close="true">
                    <button type="button" class="btn btn-primary btn-time btn-block fs-14px px-1" :disabled="idSelect.length == 0">Thao tác</button>
                    <ldc-dropdown-menu>
                        <div class="action-checked">
                            <button class="btn-block btn-dropdown-action border-0 bg-white text-left py-1 px-10px mt-0"
                                @click="destroy()" close-dropdown :disabled="statusAction == 'destroy'">Xoá</button>
                            <!-- <button class="btn-block btn-dropdown-action border-0 bg-white text-left py-1 px-10px mt-0">Up lên đầu</button>
                            <button class="btn-block btn-dropdown-action border-0 bg-white text-left py-1 px-10px mt-0">Up tự động</button> -->
                        </div>
                    </ldc-dropdown-menu>
                </ldc-dropdown>
            </div>
            <div class="col-5">
                <div class="row">
                    <div class="col-6">
                        <ldc-select
                            filterable
                            placeholder="Chọn danh mục"
                            v-model="data.category">
                            <ldc-option
                                v-for="(item, index) in categories" :key="index"
                                :value="item.id"
                                :label="`${item.name} ( ${item.count} )`"/>
                        </ldc-select>
                    </div>
                    <div class="col-6">
                        <ldc-select
                            placeholder="Lọc"
                            v-model="data.fillter">
                                <ldc-option
                                    v-for="(data, index) in dataFillter" :key="index"
                                    :value="data.value"
                                    :label="data.name"/>
                        </ldc-select>
                    </div>
                </div>
            </div>
            <div class="col-5">
                <div class="row">
                    <div class="col-9">
                        <div class="search position-relative">
                            <input type="text" class="w-100 bg-white fs-14px" placeholder="Nhập #id hoặc tiêu đề tin" @keyup.enter="enterKeyword()" v-model="keyword"/>
                            <div class="btn-search position-absolute" @click="enterKeyword()">
                                <span class="lable-search px-10px">
                                    <i class="icon ion-ios-search fs-20px"></i>
                                </span>
                            </div>
                            <div class="text-warning-search fs-10px position-absolute">
                                * Ghi # để tìm kiếm theo id ( vd: <i>#123456</i> )
                            </div>
                        </div>
                    </div>
                    <div class="col-3">
                        <button class="btn btn-block border-0 fs-14px btn-cancel-filter" style="height: 35px;" @click="removeFillter()">Bỏ lọc</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <div class="action-table-mobile">
            <div input-search>
                <div content-input-search class="search-box position-relative">
                    <input type="text" placeholder="Nhập id hoặc tiêu đề tin" v-model="keyword" @keyup.enter="enterKeyword()"/>
                    <div class="text-warning-search fs-10px"> * Ghi # để tìm kiếm theo id ( vd: <i>#123456</i> ) </div>
                </div>
            </div>
            <div class="d-flex mb-10px">
                <div class="w-50 pr-1">
                    <button type="button" class="btn btn-primary btn-action-check btn-block fs-14px px-1" :disabled="idSelect.length == 0" @click="showActionMuti = true">
                        Thao tác
                    </button>
                </div>
                <div class="w-50 pl-1">
                    <button type="button" class="btn btn-primary time-date btn-block bg-white fs-14px pl-10px"
                        @click="fillterMobile = true">
                        <i class="icon ion-ios-options fs-18px mr-2"></i>Lọc nâng cao
                    </button>
                </div>
            </div>
        </div>
        <ldc-model-mobile
            titileCancel="Hủy"
            :showCancel="true"
            :showTitle="true"
            title="Thao tác các mục đã chọn"
            :visible.sync="showActionMuti">
            <ul slot="content-model"
                :class="{
                    'list-android mb-0': $isAndroid,
                    'list-ios mb-0': !$isAndroid
                }">
                <!-- <li>
                    <button type="button" class="btn-action-hover btn-block">Up lên đầu</button>
                </li>
                <li>
                    <button type="button" class="btn-action-hover btn-block">Up tự động</button>
                </li> -->
                <li>
                    <button type="button" class="btn-action-hover btn-remove btn-block"
                        close-model-mobile @click="destroy()">Xoá</button>
                </li>
            </ul>
        </ldc-model-mobile>
        <ldc-model-mobile
            titileCancel="Hủy"
            :showCancel="false"
            :showTitle="true"
            title="Lọc tin rao"
            :customButton="true"
            :visible.sync="fillterMobile">
            <div slot="content-model"
                :class="{
                    'fillter-android': $isAndroid,
                    'fillter-ios': !$isAndroid,
                }">
                <div class="item-fillter" role="button">
                    <ldc-select-mobile
                        placeholder="Chọn danh mục"
                        title="Lọc theo danh mục"
                        v-model="data.category">
                        <ldc-option-mobile
                            v-for="(item, index) in categories" :key="index"
                            :value="item.id"
                            :label="`${item.name} ( ${item.count} )`"/>
                    </ldc-select-mobile>
                </div>
                <div class="item-fillter" role="button">
                    <ldc-select-show-option
                        placeholder="Loại tin"
                        v-model="data.fillter">
                        <ldc-option-show
                            v-for="(data, index) in dataFillter" :key="index"
                            :value="data.value"
                            :label="data.name"/>
                    </ldc-select-show-option>
                </div>
            </div>
            <div slot="custom-buttom"
                :class="{
                    'fillter-android': $isAndroid,
                    'fillter-ios': !$isAndroid,
                }">
                <div :class="{
                    'btn-confirm-android': $isAndroid,
                    'btn-confirm-ios mb-10px': !$isAndroid
                    }">
                    <button class="btn btn-primary radius-ios text-uppercase mr-10px fs-14px btn-apply" @click="emitModel()" close-model-mobile>áp dụng</button>
                    <button class="btn btn-light radius-ios text-uppercase ml-10px fs-14px btn-cancel" @click="removeFillter()" close-model-mobile>Bỏ lọc</button>
                </div>
            </div>
        </ldc-model-mobile>
    </div>
</template>
<script>
import { destroy, notAction } from '@/config/hoidap';
export default {
    props: ['value', 'idSelect'],
    data() {
        return {
            categories: [],
            dataFillter: [],
            data: {
                category: '',
                fillter: '',
            },
            keyword: '',
            showActionMuti: false,
            fillterMobile: false,
            statusAction: '',
        }
    },
    watch: {
        data:{
            handler(val){
                if(this.$detect == 'web'){
                    this.emitModel();
                }
            },
            deep: true,
        },
        value: {
            handler(val){
                this.changeValue();
            },
            deep: true,
        }
    },
    created() {
        this.changeValue();
        this.getCategory();
        this.getDataFillter();
    },
    methods: {
        getCategory() {
            apiGet('/v2/profile/hoidap/group_category').then(res => {
                this.categories = res.data;
            })
        },
        getDataFillter() {
            apiGet('/v2/profile/hoidap/data_fillter').then(res => {
                this.dataFillter = res.data;
            })
        },
        changeValue(){
            this.data.category = this.value.category ? this.value.category : 0;
            this.data.fillter = this.value.fillter ? this.value.fillter : '';
            this.keyword = this.value.keyword ? this.value.keyword : '';
        },
        emitModel(){
            this.$emit('input', {
                category: this.data.category,
                fillter: this.data.fillter,
                keyword: this.keyword,
            })
        },
        enterKeyword(){
            this.emitModel();
        },
        removeFillter(){
            this.data = {
                category: 0,
                fillter: '',
            }
            this.keyword = '';
            this.emitModel();
        },
        async destroy(){
            this.statusAction = 'destroy';
            await destroy(this.idSelect, this);
            this.statusAction = '';
        }
    }
}
</script>

<style>

</style>
